export const SECONDARY = {
  DARK: '#226D54',
  DEFAULT: '#226D54',
  LIGHT: '#B1D9CD',
  LIGHTER: '#E0F1EB',
} as const;
